import { ArrowLongLeftIcon, ArrowLongRightIcon } from '@heroicons/react/24/solid'
import { useDispatch } from 'react-redux'
import { setCurrentPage } from '../../../../store/navigation'
import { useEffect } from 'react'

export default function PaginationLinks({ pager, setPage }) {

    const dispatch = useDispatch()
    const previousPage = parseInt(pager.current_page) - 1
    const nextPage = parseInt(pager.current_page) + 1

    setPage = setPage || ((page) => dispatch(setCurrentPage(page)));

    function updatePage(page) {
        if (page > 0 && page <= pager.last_page) {
            setPage(page)
        }
    }

    useEffect(() => {
        return (() => {
            setPage(1)
        })
    }, [])

    return (
        <>
            {
                pager.total > 0 &&
                <nav className="border-t border-gray-200 px-4 flex items-center justify-between sm:px-0 my-8">
                    <div className="-mt-px w-0 flex-1 flex">
                        <button
                            className="border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                            onClick={() => updatePage(previousPage)}
                        >
                            <ArrowLongLeftIcon className="mr-3 h-5 w-5 text-gray-400" aria-hidden="true" />
                            Previous
                        </button>
                    </div>
                    <div className="hidden md:-mt-px md:flex">
                        {pager.links.map((link, i) => (i > 0 && i < pager.links.length - 1 &&
                            (link.label == '...' ? (
                                <span key={i} className="border-transparent text-gray-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium">{link.label}</span>
                            ) : (
                                <button key={i}
                                    className={link.active
                                        ? 'border-blue-500 text-blue-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
                                    } onClick={() => updatePage(link.label)}>{link.label}</button>
                            ))))}
                    </div>
                    <div className="-mt-px w-0 flex-1 flex justify-end">
                        <button
                            className="border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                            onClick={() => updatePage(nextPage)}
                        >
                            Next
                            <ArrowLongRightIcon className="ml-3 h-5 w-5 text-gray-400" aria-hidden="true" />
                        </button>
                    </div>
                </nav>
            }
        </>
    )
}
